import React, { Component } from 'react';
import classnames from 'classnames';

const icons = require('./icons');

export default class Icon extends Component {

  render() {
    const { clickable, size, className, icon, ...props } = this.props;
    const classes = ['icon', className];

    if (clickable) {
      classes.push('clickable');
    }

    if (typeof size === 'string') {
      classes.push(size);
    }

    const setHtml = () => ({ __html: icons[icon] || '' });

    return (
      <i
        data-name={icon}
        className={classnames(classes)}
        dangerouslySetInnerHTML={setHtml()}
        {...props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/Icon.js